import { TooltipPosition } from './types'

export function getTipWrapperWidth(
  position: TooltipPosition,
  targetBoundaries: DOMRect,
): string | undefined {
  if (['right', 'left', 'right_bottom', 'left_bottom'].includes(position)) {
    return `calc(100vw + ${targetBoundaries.width}px)`
  }

  return undefined
}
